import { InhibitorType, InhibitorTypeNames } from '../../types/ViewModel/CargoTempLog/InhibitorType';

// The view model for the dropdown options will be an array of objects
// with value and label properties, suitable for OdfjellInputComponent.
export const inhibitorSelectOptions = Object.keys(InhibitorType)
    .filter((key) => isNaN(Number(key))) // Filter out numeric keys from enum's reverse mapping (e.g., '1': 'PTBC')
    .map((key) => {
        const enumValue = InhibitorType[key as keyof typeof InhibitorType]; // Get the numeric value of the enum member (e.g., InhibitorType.PTBC which is 1)
        return {
            value: enumValue, // Use the numeric enum value (e.g., 1) for the option's value
            label: InhibitorTypeNames[enumValue], // Use the descriptive name from InhibitorTypeNames (e.g., 'PTBC (para-tertiary butyl catechol)') for the label
        };
    });
